module.exports = __webpack_public_path__ + "static/media/piercing-selected.41bfddfc.png";